import DateFnsUtils from '@date-io/date-fns';
import { ChangeEvent } from 'react';

export enum Category {
  Incident = 'Incident',
  SecurityIncident = 'Security-Incident',
  Maintenance = 'Maintenance',
  Update = 'Update',
}

export enum Status {
  Up = 'up',
  Down = 'down',
  Degraded = 'degraded',
  Announcement = 'announcement',
  Started = 'started',
  Completed = 'completed',
}

export interface RenderPreviewProps {
  category: string;
  name: string | undefined;
  status: string;
  title: string;
  authorName: string;
  description: string;
  instance: string;
  startDate: Date | null;
  endDate: Date | null;
  dateFns: DateFnsUtils;
}

export type CreateDateTimePickerComponentProps = {
  status: Status;
  startDate: string | null;
  endDate: string | null;
  handleStartDateChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleEndDateChange: (event: ChangeEvent<HTMLInputElement>) => void;
};
